import React, { ReactElement } from 'react';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import { Draw, DrawMap, DrawOptions } from 'leaflet';
import { DrawShapeControl } from '..';
import { MapViewerPanel } from '../../../redux';
import { useTranslation } from 'react-i18next';

export function DrawCircleControl(): ReactElement {
	const { t } = useTranslation('map');
	const defaultCircleOptions: DrawOptions.CircleOptions = {
		shapeOptions: {
			fill: false,
			fillOpacity: 0,
			color: '#000'
		}
	};

	function createCircleFeature(map: DrawMap): Draw.Feature {
		return new Draw.Circle(map, defaultCircleOptions);
	}

	return (
		<DrawShapeControl
			controlPanel={MapViewerPanel.DrawCircle}
			tooltip={t('actionButtons.edit.circle')}
			icon={<RadioButtonUncheckedIcon />}
			createFeature={createCircleFeature}
		/>
	);
}
